import React, { useEffect } from "react";
import {
  IThemeConfig,
  useTheme,
  getConfig,
  PageDescription,
  PageTitle,
} from "../../../../_start/layout/core";
import { ProjectDashboardPage } from "./ProjectDashboardPage";
import { useLocation, Navigate } from "react-router";

const defaultPageConfig = getConfig();
const dashboardPageConfig: Partial<IThemeConfig> = {
  aside: {
    ...defaultPageConfig.aside,
    display: true,
    primaryDisplay: true,
    secondaryDisplay: false,
    toggle: true,
    content: "menu",
  },
  toolbar: {
    ...defaultPageConfig.toolbar,
    display: false,
  },
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: false,
  },
};

export function ProjectDashboardWrapper() {
  const { setTheme } = useTheme();
  const location = useLocation();
  const state = location.state as {
    projectTitle: string;
    projectID: string;
    projectDescription: string;
    userID: string;
  } | null;

  // Refresh UI after config updates
  useEffect(() => {
    if (state) {
      setTheme(dashboardPageConfig);
      return () => {
        setTheme(defaultPageConfig);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!state) {
    return <Navigate to="/" replace />;
  }

  const { projectTitle, projectID, projectDescription, userID } = state;

  return (
    <>
      <ProjectDashboardPage userID={userID} projectID={projectID} projectTitle={projectTitle} projectDescription={projectDescription} />
      <PageTitle>{projectTitle}</PageTitle>
      <PageDescription>{projectDescription}</PageDescription>
    </>
  );
}
